import React from "react";
import BeyogluSidebar from "../Sidebar/BeyogluSidebar";
import BeyogluOtherServices from "../ServiceAreas/BeyogluServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BeyogluIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BEYOĞLU HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Beyoğlu’nun tarihi dokusu ve modern yaşam tarzı, ev hijyenini ön plana çıkarıyor.
            Biz de bu bilinçle, halı ve koltuklarınızı derinlemesine temizleyerek yaşam alanlarınızı
            tazelikle buluşturuyoruz. Profesyonel temizlik ekibimiz ve gelişmiş makinelerimizle
            her adımda titizlikle çalışıyoruz.
          </p>

          <p>
            Halılarınız türüne göre özel yıkama sistemlerinden geçirilir; koltuklar ise kumaş
            yapısına uygun temizlik ürünleriyle, yerinde veya fabrikamızda itinalı bir şekilde
            temizlenir.
          </p>

          <p>
            <strong>Hizmetimizin öne çıkan avantajları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Beyoğlu’nun tüm mahallelerine ücretsiz servis imkânı</li>
            <li>Antibakteriyel buharlı koltuk yıkama</li>
            <li>Organik halı şampuanları ile derinlemesine hijyen</li>
            <li>Leke çıkarma garantili temizlik uygulamaları</li>
            <li>Yorgan, battaniye ve perde yıkama hizmeti</li>
            <li>Hızlı teslimat süresi ve müşteri memnuniyeti garantisi</li>
          </ul>

          <p>
            Cihangir, Kasımpaşa, Tophane, Karaköy, Sütlüce, Hasköy ve İstiklal Caddesi çevresi
            başta olmak üzere tüm Beyoğlu genelinde hizmet sağlıyoruz. Mobil ekiplerimizle
            yerinden alım ve zamanında teslimat süreçlerini eksiksiz yürütüyoruz.
          </p>

          <p>
            Halılar önce toz alma işleminden geçer, ardından tam otomatik makinelerde yıkanır.
            Koltuklar ise özel buhar ve fırçalama sistemleriyle detaylı bir temizlikten geçirilir.
          </p>

          <p>
            Temiz ve sağlıklı yaşam alanları için bizi tercih edebilirsiniz. Hemen iletişim sayfamızdan
            bize ulaşarak sipariş verebilir, fiyat teklifi alabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <BeyogluSidebar />
          <BeyogluOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BeyogluIntro;
